import React from "react";
import {ExternalLink} from "../../../utils/cms/types";
import {isCI} from "../../../utils/env";
import Link from "next/link";

type Props = {
  externalLink: ExternalLink;
};

export const ExternalLinkRow = ({externalLink}: React.PropsWithChildren<Props>) => {
  const {title, url, description} = externalLink;

  return (
    <Link
      key={url}
      href={url}
      {...(!isCI && {
        target: "_blank",
        rel: "noopener noreferrer",
      })}
      className="df fdc p6 p4-sm br5 br0-xs t-100 hover-bg-gray100"
    >
      <div className="df jcsb">
        <div className="df aic">
          <div className="df fdc oh tofe gray600 font-im fs14">
            <>
              <span className="fs22 fs18-lg gray800 font-csb oh tofe">{title}</span>
              {Boolean(description) && <span className="df aic fw t-100">{description}</span>}
            </>
          </div>
        </div>
      </div>
    </Link>
  );
};
